import {Component, OnInit} from '@angular/core';
import {faCrown} from '@fortawesome/free-solid-svg-icons';
import {Subscription} from "rxjs";
import _ from 'lodash';
import {Session} from "src/app/shared/models/session.model";
import {UserService} from "src/app/shared/services/user.service";
import {SessionService} from "src/app/shared/services/session.service";
import {CardValues} from "src/app/shared/game/card";

@Component({
  selector: 'app-home-game-score',
  templateUrl: './game-score.component.html',
  styleUrls: ['./game-score.component.scss']
})
export class GameScoreComponent implements OnInit {
  readonly faCrown = faCrown;

  private $session: Subscription;
  session: Session;

  constructor(private userService: UserService,
              private sessionService: SessionService) {
  }

  ngOnInit(): void {
    this.session = this.sessionService.session.value;
    this.$session = this.sessionService.session.subscribe(this.onSessionChange.bind(this));
  }

  onSessionChange(session: Session): void {
    if (_.isEqual(this.session, session)) {
      return;
    }
    this.session = session;
  }

  wildCard(round: number): string {
    const value = round + 2;
    if (CardValues[value]) {
      return CardValues[value];
    } else {
      return (round + 2).toString();
    }
  }

  quit() {
    this.sessionService.sessionKey.next(null);
  }

  getOuts(scores: Array<number>) {
    return scores.filter(x => x === 0).length;
  }
  
  getAverage(scores: Array<number>) {
    const sum = scores.reduce((a, b) => a + b);
    return Math.round((sum / scores.length) || 0);
  }
}
